import axios from "axios";
import Cookies from "universal-cookie";
import { DeleteAllDataForLogin } from "../Tools/LocalStorage";

const AxiosInstance = axios.create({
    baseURL: process.env.REACT_APP_WEB_API_URL
})

AxiosInstance.interceptors.response.use(
    (response) => {
        return response;
    }, 
    (error) => {
        const status = error?.response?.status ?? "NO_STATUS";
        const cookies = new Cookies();
        if (status === 401) {
            cookies.remove("id", { path: "/" });
            cookies.remove("user", { path: "/" });
            cookies.remove("name", { path: "/" });
            cookies.remove("type", { path: "/" });
            cookies.remove("token", { path: "/" });
            cookies.remove("currency", { path: "/" });
            DeleteAllDataForLogin();

            const isAdminRoute = window.location.pathname.startsWith("/admin");
            const loginPath = isAdminRoute ? "/admin/login" : "/login";
            if (window.location.pathname !== loginPath) {
                window.location.href = loginPath;
            }
        }

        return Promise.reject(error);
    }
);

export default AxiosInstance
